
import axios from "../network/reuset"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getConfig = {
  getConfigList(params) {
    return axios.post(
      `/api/admin/config/list`,
      qs.stringify(params)
    );
  },
  postSaveConfig(params) {
    return axios.post(
      `/api/admin/config/save`,
      qs.stringify(params)
    );
  },
  getConfig(params) {
    return axios.post(
      `/api/admin/config/get_config`,
      qs.stringify(params)
    );
  },
  postAddConfig(params) {
    return axios.post(
      `/api/admin/config/add`,
      qs.stringify(params)
    );
  },
};
export default getConfig;
